export default "__VITE_ASSET__D7bdB7Zg__"